import React, { useRef, useState, useEffect } from "react";
import { Uploader, Progress, Button } from "rsuite";
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';

const Dashboard = () => {

const [tabName, setTabName] = useState('Dashboard');

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

    return (
        <>
            <Sidebar />
            <div id='header'>
                <div className='logo'>
                    <div className='logo_icon'>
                        <img src={Logo} alt="Logo" />
                    </div>
                    <div className='brand_name'>Dashboard</div>
                </div>

                <div className='header_table_filter'>
                    <div className='searchfield'>
                        <button className='btn_search'><i className='icon-search2'></i></button>
                        <input
                            type='text'
                            className='filter_searchfield'
                            placeholder='Search'
                            autoComplete="off"
                        />
                    </div>

                    <a
                        href="#"
                        className="btn_clear_filter"
                        style={{ textDecoration: "none" }}
                    >
                        Clear Filters
                    </a>
                </div>
            </div>

            <div className="container-fluid" style={{ paddingLeft: 40, paddingRight: 40 }}>
                <ul className="row dashboard__row">
                    <li className="col-sm-6 col-lg-3 mt-4">
                        <a href="#">
                            <h4>721</h4>
                            <h5>Total Investors</h5>
                        </a>
                    </li>

                    <li className="col-sm-6 col-lg-3 mt-4">
                        <a href="#">
                            <h4>$85,000</h4>
                            <h5>Total Invested</h5>
                        </a>
                    </li>
                    <li className="col-sm-6 col-lg-3 mt-4">
                        <a href="#">
                            <h4>42,500</h4>
                            <h5>Total Shares Issued</h5>
                        </a>
                    </li>
                    <li className="col-sm-6 col-lg-3 mt-4">
                        <a href="#">
                            <h4>200</h4>
                            <h5>Total Investors</h5>
                        </a>
                    </li>
                </ul>

                <h5 className="mt-5 page__title">Top 5 Recent Investors</h5>
                <div className='company_table_list table-responsive mt-4'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Mobile/Email</th>
                                <th>Country</th>
                                <th>Investment Amount</th>
                                <th>Shares</th>
                                <th>Investor Type</th>
                                <th>Date of Investment</th>
                            </tr>
                        </thead>
                       <tbody>
  <tr>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      Ahmed Khan
    </td>
    <td style={{ fontWeight: 600, fontSize: 14, color: '#4D4D4D' }}>
      ahmed.khan@email.com<br />+971501234567
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      UAE
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      $25,000
    </td>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      12,500
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      Corporation
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      09 May 2025
    </td>
  </tr>
  <tr>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      Fatima Al-Sayed
    </td>
    <td style={{ fontWeight: 600, fontSize: 14, color: '#4D4D4D' }}>
      fatima.sayed@email.com<br />+966512345678
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      Saudi Arabia
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      $20,000
    </td>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      10,000
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      Individual
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      08 May 2025
    </td>
  </tr>
  <tr>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      Yusuf Abdullah
    </td>
    <td style={{ fontWeight: 600, fontSize: 14, color: '#4D4D4D' }}>
      yusuf.abdullah@email.com<br />+44 7123 456789
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      UK
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      $15,000
    </td>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      7,500
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      Joint
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      07 May 2025
    </td>
  </tr>
  <tr>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      Ayesha Malik
    </td>
    <td style={{ fontWeight: 600, fontSize: 14, color: '#4D4D4D' }}>
      ayesha.malik@email.com<br />+91 9876543210
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      India
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      $10,000
    </td>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      5,000
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      Trust
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      06 May 2025
    </td>
  </tr>
  <tr>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      Imran Nazir
    </td>
    <td style={{ fontWeight: 600, fontSize: 14, color: '#4D4D4D' }}>
      imran.nazir@email.com<br />+92 3012345678
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      Pakistan
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      $8,000
    </td>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      4,000
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      Individual
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
      05 May 2025
    </td>
  </tr>
</tbody>

                    </table>
                </div>
            </div>
        </>
    );
};

export default Dashboard;
